<ng-template pu-mat-dialog-title>
    {{ "password.modifypwd" | translate }}
</ng-template>

<div class="card-body px-lg-5 py-lg-5 px-2">
    @let context = { mode: 'change-password-after-login', onsubmit: this };
    <ng-container *puTemplateOutlet="'authForms'; context: context"></ng-container>
</div>